import { useEffect } from "react"

interface TitleForm {
	setValue: (name: "title", value: string) => void
}

// Seed on every open: form.reset() after a create restores the mount-time title, which can belong to another thread.
export function useSeedTitleOnOpen(
	form: TitleForm,
	isOpen: boolean,
	title: string | undefined,
) {
	useEffect(() => {
		if (isOpen) form.setValue("title", title ?? "")
	}, [form, isOpen, title])
}
